import styled, { css } from 'styled-components'

import { FormGroup } from '~/components/unform'
import { device } from '~/styles/device'

export const Header = styled.div`
  display: flex;
  gap: 2rem;

  @media ${device.tablet_max} {
    flex-direction: column;
  }
`

export const RangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`

export const Title = styled.p`
  margin: 0;
  padding: 0;
`

export const FormWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: end;

  @media ${device.laptopL_max} {
    flex-direction: column;
  }
`

export const FormGroupName = styled(FormGroup)`
  flex: 1;

  @media ${device.laptopL_max} {
    width: 100%;
  }
`

export const BudgetAndDateWrapper = styled.div`
  display: flex;
  gap: 1rem;

  @media ${device.laptopL_max} {
    width: 100%;
  }

  @media ${device.tablet_max} {
    flex-direction: column;
  }
`
